import FFP from './frequent-flyer-program-enum';

export const frequentFlyerNumberRegex = {
  [FFP.AEROFLOT]: /^[0-9]{4,8}$/, // 50101041
  [FFP.AEROLINEAS]: /^(?!0{7,8}$)[0-9]{7,8}$/, // 1225317
  // [FFP.AEROMAR]: /^(00)[0-9]{9}|[0-9]{9}$/,
  [FFP.ALASKA]: /^[0-9]{12}$/, // 000009876543
  // [FFP.ALITALIA]: /^[0-9]{10}$/,
  [FFP.AVIANCA]: /^[0-9]{2,11}$/, // 20202145784
  [FFP.AVIANCA_BRASIL]: /^[0-9]{10}$/, // 2020214578
  [FFP.CHINA]: /^([A-Za-z]{2})(?!0{7}$)[0-9]{7}$/, // AA2544906
  [FFP.CHINA_EASTERN]: /^(?!0{12}$)[0-9]{12}$/, // 650600008888
  [FFP.CHINA_SOUTHERN]: /^[0-9]{11,19}$/, // 180006600036
  // [FFP.COPA]: /^[0-9]{9}$/, // 180006600036
  // [FFP.CZECH]: /^[0-9]{8}$/, // 10000117
  [FFP.DELTA]: /^(?!0{10}$)[0-9]{10}$/, // 2042775656
  [FFP.FRANCE]: /^(?!0{10}$)[0-9]{10}$/, // 2003713035
  [FFP.GARUDA]: /^(?!0{9}$)[0-9]{9}$/, // 572544906
  [FFP.GOL]: /^(?!0{9}$)[0-9]{9}$/, // 999989874
  [FFP.KENYA]: /^(?!0{10}$)[0-9]{10}$/, // 1234567891
  [FFP.KLM]: /^(?!0{10}$)[0-9]{10}$/, // 2003713035
  [FFP.KOREAN]: /^(?!0{9,12}$)[A-Za-z0-9]{9,12}$/, // 160193961
  [FFP.LATAM]: /^(?!0{6,12}$)[0-9A-Z]{6,12}$/, // 160193961
  [FFP.MIDDLE_EAST]: /^(?!0{12}$)[0-9]{12}$/, // 191001017134
  [FFP.SAS]: /^[a-zA-Z]{3}(?!0{9})\d{9}$/, // EBB544325236
  [FFP.SAUDIA]: /^(?!0{8}$)[0-9]{8}$/, // 46231916
  [FFP.TAROM]: /^(?!0{10}$)[0-9]{10}$/, // 1234567891
  [FFP.VIETNAM]: /^(?!0+$)(?=[0-9]*$)(?:.{8}|.{10})$/, // 91001017
  [FFP.WESTJET]: /^[0-9]{9}$/, // 123456789
  [FFP.XIAMEN]: /^(?!0{10}$)[0-9]{10}$/, // 160193961
};

export const corporateFrequentFlyerRegex = {
  [FFP.DELTA]: [
    /^(SME|sme)([0-9]{5})$/,
    /^(EQ|eq|ER|er|ES|es)([A-Za-z0-9]{3})$/,
    /^(US|CA|MX|us|ca|mx)([0-9]{9})$/,
    /^(US|CA|MX|us|ca|mx)([0-9]{7})$/,
    /^$/,
  ],
};
